import React, { useEffect, useState } from 'react';
import './assets/css/LoadingScreen.css';


const LoadingScreen = () => {
    const domain = window.location.hostname;
    const [loadingIcon, setLoadingIcon] = useState();

    useEffect(() => {
        // Recupera o ícone de carregamento do localStorage
        // const cachedImages = JSON.parse(localStorage.getItem(`custom_images_${domain}`)) || {};
        setLoadingIcon("https://plantao-rapido.s3.us-east-2.amazonaws.com/public/img/carregamento-plantao-rapido.gif" || null);
    }, []);

    return (
        <div className="loading-screen">
            {loadingIcon && (
                <img src={loadingIcon} alt="Loading..." />
            )}
        </div>
    );

};

export default LoadingScreen;
